import { VisuallyHidden as VisuallyHiddenPrimitive } from 'radix-ui';
import type { ComponentPropsWithoutRef } from 'react';

/** Content for assistive technology only (still in the accessibility tree, invisible on screen). */
export function VisuallyHidden(
  props: ComponentPropsWithoutRef<typeof VisuallyHiddenPrimitive.Root>,
) {
  return <VisuallyHiddenPrimitive.Root {...props} />;
}
